<template>
  <div>
    <v-row justify="space-between">
      <h3 class="title white--text">{{ displayTitle }}</h3>
      <div>
        <g-button label="Return" @onclick="$router.push({ name: 'admin_ai_prompts' })" />
        <save-button :onsave="updateAiPrompts" />
      </div>
    </v-row>
    <a-card>
      <elwrapper label="Prompt">
        <f-textarea v-model="prompt" rows="20" />
      </elwrapper>
    </a-card>
  </div>
</template>

<script>
import AI_PROMPTS_CONFIG from "@/config/AI_PROMPTS_CONFIG";

export default {
  components: {},
  data() {
    return {
      prompt: "",
    };
  },
  computed: {
    refkey() {
      return this.$route.params.name;
    },
    displayTitle() {
      const config = Object.values(AI_PROMPTS_CONFIG).find((item) => item.name === this.refkey);
      return config ? config.label : "AI Prompt";
    },
  },
  methods: {
    getAiPrompt() {
      this.$store
        .dispatch("AiPromptsStore/getAiPromptByName", this.refkey)
        .then((data) => (this.prompt = data.prompt))
        .catch((err) => this.$root.$error(err));
    },
    updateAiPrompts() {
      return this.$store
        .dispatch("AiPromptsStore/updateAiPrompts", { name: this.refkey, prompt: this.prompt })
        .then(() => this.$root.$success("Ai Prompts updated"))
        .catch((err) => this.$root.$error(err));
    },
  },
  mounted() {
    this.getAiPrompt();
  },
};
</script>
